<ion-list>
  <ion-menu-toggle menu="main-menu" auto-hide="false">
    <!-- Unwrap items$ -->
    @if (items$ | async; as items) {

      <!-- Loop through top-level items -->
      @for (item of items; track item.id) {
        <ion-item button 
          [routerLink]="item.url" 
          routerLinkActive="selected"
          [routerLinkActiveOptions]="
            item.url === '/' 
              ? { exact: true }   
              : { exact: false }  
          "
          (click)="item.action?.()"
          >
          @if (item.icon) {
            <ion-icon slot="start" [name]="item.icon"></ion-icon>
          }
          <ion-label>
            {{ item.label }}
          </ion-label>

          <!-- 🔹 Assessments CHIP -->
          @if (item.id === 'assessments') {
            @if (countsService.counts$ | async; as counts) {
              @if (counts.assessmentsActive > 0) {
                <ion-chip slot="end" color="info">
                  <ion-label>{{ counts.assessmentsActive }}</ion-label>
                </ion-chip>
              }
            }
          }

          @if (item.id === 'missions') {
            @if (countsService.counts$ | async; as counts) {
              @if (counts.missionsOffered > 0) {
                <ion-chip slot="end" color="info">
                  <ion-label>{{ counts.missionsOffered }}</ion-label>
                </ion-chip>
              }
            }
          }

          <!-- 🔹 resources CHIP -->
          @if (item.id === 'resources') {
            @if (countsService.counts$ | async; as counts) {
              @if (counts.resources > 0) {
                <ion-chip slot="end" color="info">
                  <ion-label>{{ counts.resources }}</ion-label>
                </ion-chip>
              }
            }
          }

          <!-- 🔹 NEWS CHIP -->
          @if (item.id === 'news') {
            @if (countsService.counts$ | async; as counts) {
              @if (counts.news > 0) {
                <ion-chip slot="end" color="info">
                  <ion-label>{{ counts.news }}</ion-label>
                </ion-chip>
              }
            }
          }

          <!-- 🔹 INVOICES CHIP -->
          @if (item.id === 'invoices') {
            @if (countsService.counts$ | async; as counts) {
              @if (counts.invoices > 0) {
                <ion-chip slot="end" color="info">
                  <ion-label>{{ counts.invoices }}</ion-label>
                </ion-chip>
              }
            }
          }

          <!-- 🔹 PROFILE CHIP -->
          @if (item.id === 'account') {
            @if (countsService.counts$ | async; as counts) {
              @if (counts.profileComplete > 0) {
                <ion-chip slot="end" color="info">
                  <ion-label>{{ counts.profileComplete }}%</ion-label>
                </ion-chip>
              }
            }
          }

          <!-- 🔹 FORUM CHIP -->
          @if (item.id === 'forum') {
            @if (countsService.counts$ | async; as counts) {
              @if (counts.forumUnreadPosts > 0) {
                <ion-chip slot="end" color="info">
                  <ion-label>{{ counts.forumUnreadPosts }}</ion-label>
                </ion-chip>
              }
            }
          }
          
          
          @if (item.meta) {
            <ion-chip slot="end">Default</ion-chip>
          }
        </ion-item>

        <!-- Optional children -->
        @if (0 && item.children?.length) {
          @for (child of item.children; track child.id) {
            <ion-item button class="child-item" (click)="onClick(child)">
              @if (child.icon) {
                <ion-icon slot="start" [name]="child.icon"></ion-icon>
              }
              <ion-label>{{ child.label }}</ion-label>
            </ion-item>
          }
        }
      }
    }

    @if (0) {
      <ion-item button routerLink="/">
        Home
      </ion-item>

      <!-- Parent item -->
      <ion-item button routerLink="/account/profile" >
        Account
        
      </ion-item>

      

      <ion-item button routerLink="/settings">
        Settings
      </ion-item>
    }
    <ion-item-divider></ion-item-divider>
    <ion-item 
      button 
      (click)="onSignOut()" 
      color="medium"
      >
      <ion-icon slot="start" name="sign-out"></ion-icon>
      <ion-label>Sign Out</ion-label>
    </ion-item>

    

     
  
  </ion-menu-toggle>

  

 


</ion-list>






